<label for="category" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{
  name
}}</label>
